<div class="search-wrapper">
	<p-autoComplete
		placeholder="Search"
		[(ngModel)]="query"
		(completeMethod)="search()"
		[suggestions]="results"
		field="title"
		styleClass="search"
		(onSelect)="select($event)"
		(keydown.enter)="onEnter()"
		[showEmptyMessage]="true"
	>
		<ng-template pTemplate="item" let-result>
			<div class="search-result-item">
				<i class="pi pi-briefcase search-result-icon"></i>
				<div class="search-result-content">
					<app-search-job-result [result]="result"></app-search-job-result>
				</div>
				<div class="search-result-right">
					<app-job-status-pill
						*ngIf="result.state"
						[state]="result.state"
						[stage]="result.stage"
					></app-job-status-pill>
					<div *ngIf="result.zoneName" class="search-result-zone">{{ result.zoneName }}</div>
				</div>
				<i class="pi pi-chevron-right search-result-arrow"></i>
			</div>
		</ng-template>
	</p-autoComplete>
	<button class="search-icon-btn" (click)="onEnter()" title="Search">
		<p-progressSpinner *ngIf="loading" styleClass="search-spinner" strokeWidth="3" [style]="{'width': '20px', 'height': '20px'}"></p-progressSpinner>
		<i *ngIf="!loading" class="pi pi-search"></i>
	</button>
</div>